// icons
import { ChevronDown } from 'lucide-react';
// components
import { PopoverButton } from '@newo/ui-kit';
import { TPersona, IActor } from '@newo/api/gateway';
import SelectUserForm from '@/modules/Analytics/components/Toolbar/components/SelectUserForm';
// utils
// assets
import styles from '@/modules/Analytics/components/Toolbar/components/UserSelector/UserSelector.module.css';

interface UserSelectorProps {
    persona?: TPersona;
    actor?: IActor;
    onSelect: (persona?: TPersona, actor?: IActor) => void;
}

const UserSelector = ({ persona, actor, onSelect }: UserSelectorProps) => {
    const handleSelect = (userPersona?: TPersona, userActor?: IActor) => {
        onSelect(userPersona, userActor);
    };

    const personaName = persona?.name ?? (
        <span className="text-gray-6">Persona</span>
    );
    const actorName = actor ? (
        `${actor.integration_idn}/${actor.connector_idn}`
    ) : (
        <span className="text-gray-6">Actor</span>
    );

    return (
        <PopoverButton
            className={styles.button}
            trigger={
                <>
                    <div className="mb-auto text-xs">User</div>
                    <div className={styles.names}>
                        <div className="flex-1">
                            {personaName}
                            <br />
                            {actorName}
                        </div>
                        <ChevronDown />
                    </div>
                </>
            }
        >
            {(close) => (
                <SelectUserForm
                    actor={actor}
                    persona={persona}
                    onClose={close}
                    onSubmit={handleSelect}
                />
            )}
        </PopoverButton>
    );
};

export default UserSelector;
